import React, { useContext, useEffect } from "react";
import { format, isPast, parseISO } from "date-fns";
import { ACCOUNT_TYPE_NORMAL } from "@config/config";
import { AuthContext } from "@context/AuthContext";
import { PromoContext } from "@context/PromoContext";
import { UserContext } from "@context/UserContext";
import "./style.scss";

const MyOffers = () => {
    const { user, isLoggedIn } = useContext(AuthContext);
    const { fetchSubscriberPromoOffers, subscriberPromoOfferDetails } = useContext(PromoContext);
    const { isLoading } = useContext(UserContext);

    useEffect(() => {
        if (isLoggedIn && user?.account_type_id === ACCOUNT_TYPE_NORMAL && !isLoading) {
            fetchSubscriberPromoOffers();
        }
    }, [isLoggedIn, user?.account_type_id]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        try {
            return format(parseISO(dateString), "dd/MM/yyyy");
        } catch {
            return dateString;
        }
    };

    const isExpired = (dateString) => {
        if (!dateString) return false;
        try {
            return isPast(parseISO(dateString));
        } catch {
            return false;
        }
    };

    if (isLoading || user?.account_type_id !== ACCOUNT_TYPE_NORMAL || !subscriberPromoOfferDetails) {
        return null;
    }

    const renderTicketAllocation = (offer) => {
        const allocations = [];
        if (offer.standard_tickets_free > 0) {
            allocations.push(`${offer.standard_tickets_free} x Standard`);
        }
        if (offer.premium_tickets_free > 0) {
            allocations.push(`${offer.premium_tickets_free} x Premium`);
        }
        if (offer.gold_tickets_free > 0) {
            allocations.push(`${offer.gold_tickets_free} x Gold`);
        }
        return allocations.join(", ");
    };

    const renderTicketRedeemed = (offer) => {
        const redeemed = [];
        redeemed.push(`${offer.standard_tickets_redeemed} x Standard`);
        redeemed.push(`${offer.premium_tickets_redeemed} x Premium`);
        redeemed.push(`${offer.gold_tickets_redeemed} x Gold`);
        return redeemed.join(", ");
    };

    return (
        <div className="my-offers">
            <div className="my-offers__table">
                <div className="my-offers__table-header">
                    <div className="my-offers__table-cell my-offers__table-cell--header-date">Date</div>
                    <div className="my-offers__table-cell my-offers__table-cell--header-details">Details</div>
                    <div className="my-offers__table-cell my-offers__table-cell--header-allocation">Ticket Allocation</div>
                    <div className="my-offers__table-cell my-offers__table-cell--header-redeemed">Ticket Redeemed</div>
                    <div className="my-offers__table-cell my-offers__table-cell--header-expiry">Expiry</div>
                </div>
                {subscriberPromoOfferDetails.map((offer, index) => (
                    <div
                        key={index}
                        className={`my-offers__table-row${isExpired(offer.ticket_expiry) ? " my-offers__table-row--expired" : ""}`}
                    >
                        <div className="my-offers__table-cell my-offers__table-cell--date">
                            {formatDate(offer.created)}
                        </div>
                        <div className="my-offers__table-cell my-offers__table-cell--details">
                            {offer.offer_description}
                        </div>
                        <div className="my-offers__table-cell my-offers__table-cell--allocation">
                            {renderTicketAllocation(offer)}
                        </div>
                        <div className="my-offers__table-cell my-offers__table-cell--redeemed">
                            {renderTicketRedeemed(offer)}
                        </div>
                        <div className="my-offers__table-cell my-offers__table-cell--expiry">
                            {formatDate(offer.ticket_expiry)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyOffers;
